export default __webpack_public_path__ + "static/hear_from_team-f214051322d92b32f90271cb296023f5.mp4";